import { Badge, tokens } from '@fluentui/react-components';
import { AvailableStatus, BadgeDangerColor, BadgeSuccessColor, BadgeWarningColor, ErrorStatus, FilledAppearance, PartiallyDeployedStatus } from '../common/constants';

export type StatusType = typeof AvailableStatus | 'Not Available' | typeof ErrorStatus | typeof PartiallyDeployedStatus | 'In Progress' | 'Failed';

interface StatusBadgeProps {
  status: StatusType;
}

/**
 * Reusable StatusBadge component with consistent styling across the application
 */
export const StatusBadge = ({ status }: StatusBadgeProps) => {
  if (status === AvailableStatus) {
    return (
      <Badge appearance={FilledAppearance} color={BadgeSuccessColor}>
        Available
      </Badge>
    );
  }

  if (status === PartiallyDeployedStatus) {
    return (
      <Badge
        appearance={FilledAppearance}
        style={{
          backgroundColor: tokens.colorStatusWarningBackground3,
          color: tokens.colorNeutralForegroundOnBrand,
        }}
      >
        Partially Deployed
      </Badge>
    );
  }

  if (status === ErrorStatus) {
    return (
      <Badge appearance={FilledAppearance} color={BadgeDangerColor}>
        Error
      </Badge>
    );
  }

  if (status === 'In Progress') {
    return (
      <Badge
        appearance={FilledAppearance}
        style={{
          backgroundColor: tokens.colorPaletteBlueBackground2,
          color: tokens.colorBrandForeground1,
        }}
      >
        In Progress
      </Badge>
    );
  }

  if (status === 'Failed') {
    return (
      <Badge
        appearance={FilledAppearance}
        style={{
          backgroundColor: tokens.colorStatusDangerBackground1,
          color: tokens.colorStatusDangerForeground1,
        }}
      >
        Failed
      </Badge>
    );
  }

  // "Not Available"
  return (
    <Badge appearance={FilledAppearance} color={BadgeWarningColor}>
      Not Available
    </Badge>
  );
};

export default StatusBadge;
